import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  isMobile = false;
  isUserWelcomeTopBG = false;

  constructor(private http: HttpClient,
              public db: AngularFirestore,
              private _location: Location
  ) {
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
    window.addEventListener('resize', (event) => {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }

  private baseUrl = `https://firestore.googleapis.com/v1/projects/${environment.firebase.projectId}/databases/(default)`;

  goBack(count?: number) {
    if (!count) {
      count = 1;
    }
    for (let i = 0; i < count; i++) {
      this._location.back();
    }
  }

  getReminderDayList(): any[] {
    return [
      { label: '45', value: 45 },
      { label: '30', value: 30 },
      { label: '15', value: 15 },
      { label: '10', value: 10 },
      { label: '5', value: 5 },
      { label: '2', value: 2 },
      { label: '1', value: 1 },
    ];
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getHost(): string {
    return window.location.origin;
  }

  getJSONData(file) {
    return this.http.get<any>(file)
      .toPromise()
      .then(res => res.data as any[])
      .then(data => data);
  }

  getHTMLData(file) {
    return this.http.get(file, { responseType: 'text' })
      .toPromise()
      .then(res => res);
  }

}
